import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AuthSubHeader from 'src/components/authSubHeader';
import FooterText from 'src/components/footerText';
import useFetch from 'src/hooks/useFetch';
import { PrecertAPIResponse } from '../precert/types';
import { APIEndpoints } from 'src/types/apiTypes';
import { LoaderContext } from 'src/context/loaderContext';
import { AuthContext } from 'src/context/authContext';



const ReviewMedPA: React.FC = () => {
  const [note, setNote] = useState<string>("Input Changes Requested Here");
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const {isManufacturer}=useContext(AuthContext)

  const { caseId, precertsId } = useParams();
  const location = useLocation();
  const queryParam = new URLSearchParams(location.search); // Parse query params

  const navigate = useNavigate();
  // const [title] = useState((location.state as { title: string }).title)
  // const [patient,setPatient] = useState((location.state as { patient: string }).patient)


  const updateNote = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNote(event.target.value);
  };
  const { data: reviewFile } =
    useFetch<{ precert_file: string }>(APIEndpoints.GET_PRECERT_REVIEW_FILE, {}, { caseId, precertId: precertsId, button_type: "review PA" })


  // const { mutate: updatePriorMutate, data: updatePriorResponse } =
  //   useFetch<PrecertAPIResponse>(APIEndpoints.UPDATE_PRIOR_AUTH, {}, {}, false);

  // useEffect(() => {
  //   if (fetchPrecertResponse) {
  //     navigate(`/cases`);
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [updatePriorResponse]);

  // const navigateToUpdatePrior = () => {
  //   const pathParams = {
  //     case_id: caseId,
  //     id: precertsId
  //   }
  //   const queryParams = {
  //     prior_authorization_approval: false,
  //     status: 14,
  //     case_id: caseId,
  //   }
  //   // setPrecertPathParameters(pathParams)
  //   updatePriorMutate({}, pathParams, queryParams)
  // }
  // const handleRequestChange = () => {
  //   const confirmDeny = window.confirm("Are you sure you wish to deny this precert request?");
  //   if (confirmDeny) {
  //     // Handle the logic to deny precert here
  //     if (title.includes("Med PA")){
  //       navigateToUpdatePrecert()

  //     }else{
  //       navigateToUpdatePrior()
  //     }

  //     console.log("Request denied with note:", note);
  //   }
  // };
  useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    const blockKeys = (e: KeyboardEvent) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ['p', 's', 'u'].includes(e.key.toLowerCase()) // Block Ctrl+P, Ctrl+S, Ctrl+U
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', blockKeys);
    document.addEventListener('contextmenu', (e) => e.preventDefault());

    return () => {
      document.removeEventListener('keydown', blockKeys);
      document.removeEventListener('contextmenu', (e) => e.preventDefault());
    };
  }, []);
  useEffect(() => {
    if (reviewFile) {
      hideLoader()
      // Convert Base64 to binary data
      const byteCharacters = atob(reviewFile.precert_file);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      // Create a Blob and Object URL
      const blob = new Blob([byteNumbers], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);

      // Cleanup function to revoke the object URL
      return () => URL.revokeObjectURL(url);
    }
  }, [reviewFile])



  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.UPDATE_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse) {
      setButtonDisabled(false);
      hideLoader();
     isManufacturer ? navigate(`/todos_statistics`) : navigate(`/cases`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);



  const navigateToUpdatePrecert = () => {
    const pathParams = {
      case_id: caseId,
      id: precertsId
    }
    const queryParams = {
      precert_approval: false,
      status: "pending_transcription",
      case_id: caseId,
      change_note: note,
      system_note: "Precert Changes Requested by Office.",
    }
    // setPrecertPathParameters(pathParams)
    setLoader()
    setButtonDisabled(true)
    fetchPrecertMutate({}, pathParams, queryParams)
  }
  const handleRequestChanges = () => {
    const confirmDeny = window.confirm("Are you sure you wish to deny this precert request?");
    if (confirmDeny) {
      // Handle the logic to deny precert here
      // const title = queryParam.get('title');
      // if (title && title.includes("Med PA")) {
      navigateToUpdatePrecert()
      //} 

     // console.log("Request denied with note:", note);
    }
  };
  const handleApproveAndSubmitToInsuranceChanges = () => {
    const confirmDeny = window.confirm("Are you sure wish to send this precert to the insurance company? This cannot be undone!");
    if (confirmDeny) {
      const pathParams = {
        case_id: caseId,
        id: precertsId
      }
      const queryParams = {
        precert_approval: false,
        status: "submitted",
        case_id: caseId,
        system_note: "Precert Submitted by office."
      }
      // setPrecertPathParameters(pathParams)
      setLoader()
      setButtonDisabled(true)
      fetchPrecertMutate({}, pathParams, queryParams)

     // console.log("Request denied with note:", note);
    }
  };

    return (
        <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
            <div className="bg-mist py-2">
                <div className="container-fluid">
                    <AuthSubHeader/>
                </div>
            </div>
            <div className="container-fluid pt-2 d-flex flex-column flex-fill">
                <h2 className="m-0 page-heading">
                    {queryParam.get('title')}
                </h2>
                <p className="fw-bold m-0 fs-5">(Insurance Name: {queryParam.get('insuranceName')})</p>
                <p>
                    Review the below information and select "Approve" to have the form sent to the insurance
                    company.
                    Alternatively, input any requested changes or updates in the notes field and click "Request
                    Changes"
                    below.
                </p>
                <div className="card p-0">
                    <div className="card-body">
                        <div className="iframe-container">
                            {pdfUrl && reviewFile && reviewFile.precert_file && reviewFile.precert_file.length > 0 ? (
                                <iframe
                                    title="Precert PDF"
                                    src={pdfUrl + `#view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
                                    style={{width: "100%", height: "70vh", pointerEvents: 'auto'}}
                                    onContextMenu={(e) => e.preventDefault()}>
                                </iframe>

                            ) : (
                                <>
                                    <div>
                                        <p className="fw-bold fs-5" style={{color: '#808285'}}>Form not uploaded, please
                                            contact support.</p>
                                    </div>
                                </>
                            )}

                        </div>

                        <div className="d-flex gap-3 my-2">
                            <label htmlFor="note" className="form-label">Notes</label>
                            <textarea
                                name="note" id="note" className="form-control"
                                value={note} onChange={updateNote}
                                style={{resize: "none"}} rows={4}
                            >
                            </textarea>
                        </div>
                        <div className='row mt-3'>
                            <div className='d-flex gap-2'>
                                <button
                                    className="btn btn-primary"
                                    onClick={handleRequestChanges}
                                    disabled={buttonDisabled}
                                >
                                    Request Changes
                                </button>
                                {reviewFile && reviewFile.precert_file && reviewFile.precert_file.length > 0 &&
                                    <button
                                        className="btn btn-lg btn-success"
                                        onClick={handleApproveAndSubmitToInsuranceChanges}
                                        disabled={buttonDisabled}
                                    >
                                        Approve and Submit to Insurance
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterText footerType="black"/>
        </div>
    );
};

export default ReviewMedPA;
